export const EXTERNAL_LINKS = {
  notionLumaArticle: 'https://weavyai.notion.site/Luma-Dream-Machine-on-Weavy-10b355cab8da8071a82fd1e8db4c5045?pvs=25',
  discordInvite: 'https://discord.gg/jB6vn2ewxW',
  designAppTutorial: 'https://help.weavy.ai/en/articles/12267755-tools',
  importModelTutorial: 'https://www.youtube.com/watch?v=tBIjC5BUGg0',
  termsOfService: 'https://content.weavy.ai/terms-of-service',
  privacyPolicy: 'https://content.weavy.ai/privacy-policy',
  browserConfiguration: 'https://help.weavy.ai/en/articles/12449982-how-do-i-configure-my-browser-for-weavy',
  savedSectionHelp: 'https://help.weavy.ai/en/articles/15495911-using-the-saved-section',
  figmaCommunity: 'https://www.figma.com/community/ai-workflows?resource_type=files',
  figmaFiles: 'https://www.figma.com/files',
  figmaCommunityTerms: 'https://www.figma.com/legal/creator-agreement/',
  figmaCommunityGuidelines: 'https://help.figma.com/hc/articles/360038510573-Figma-Community-Guidelines',
  enterpriseContactForm: 'https://form.typeform.com/to/VmiA3c6t?startpoint=enterprise',
  figmaWeaveDeveloperTerms: 'https://help.weavy.ai/en/articles/17252270-figma-weave-developer-terms',
};

export const FIGMA_PROD_ORIGIN = 'https://www.figma.com';

/** Figma origins that serve legal pages; others (local dev, devbox) fall back to prod. */
const TERMS_CAPABLE_FIGMA_ORIGINS = new Set(['https://www.figma.com', 'https://staging.figma.com']);

/**
 * Figma's Product-Specific Terms, resolved against the embed parent origin (so a
 * staging embed links to staging), falling back to prod. Pass `useFigmaParentOrigin()`.
 */
export function getFigmaProductSpecificTermsUrl(figmaOrigin: string | null): string {
  const base = figmaOrigin && TERMS_CAPABLE_FIGMA_ORIGINS.has(figmaOrigin) ? figmaOrigin : FIGMA_PROD_ORIGIN;
  return `${base}/product-specific-terms/`;
}
